var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcReminder = function SvgIcReminder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "#4E70BB",
    d: "M18.5 14.586v.207l.146.147 1.707 1.707h.001A.5.5 0 0 1 20.5 17v1a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .146-.353l1.708-1.707.146-.147V10c0-2.985 2.028-5.502 4.778-6.26l.24-.066.092-.232A1.49 1.49 0 0 1 12 2.5c.634 0 1.17.388 1.39.942l.092.232.24.066c2.75.757 4.778 3.275 4.778 6.26zM12 21.5a2.48 2.48 0 0 1-1.994-1h3.988a2.48 2.48 0 0 1-1.993 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "#4E70BB",
    d: "M18.5 14.586v.207l.146.147 1.707 1.707h.001A.5.5 0 0 1 20.5 17v1a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .146-.353l1.708-1.707.146-.147V10c0-2.985 2.028-5.502 4.778-6.26l.24-.066.092-.232A1.49 1.49 0 0 1 12 2.5c.634 0 1.17.388 1.39.942l.092.232.24.066c2.75.757 4.778 3.275 4.778 6.26zM12 21.5a2.48 2.48 0 0 1-1.994-1h3.988a2.48 2.48 0 0 1-1.993 1Z"
  })));
};
export default SvgIcReminder;